var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "options" }, [
        _c(
          "div",
          {
            ref: "optionsList",
            class: ["list", "gantt_scroll"],
            style: { maxHeight: _vm.maxHeight + "px" },
          },
          [
            _c(
              "Container",
              {
                attrs: {
                  "drag-handle-selector": ".option-drag-handle",
                  "lock-axis": "y",
                  "auto-scroll-enabled": true,
                },
                on: {
                  drop: function ($event) {
                    return _vm.onDrop(null, _vm.optionItems, $event)
                  },
                },
              },
              _vm._l(_vm.optionItems, function (item, index) {
                return _c(
                  "Draggable",
                  {
                    key: index,
                    ref: "colorOptionItem",
                    refInFor: true,
                    class: [
                      "list__item",
                      item.id === _vm.targetOptionId ? "active" : "",
                    ],
                    attrs: { "data-color-id": item.id },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "colors-option-wrapper",
                        on: {
                          click: function ($event) {
                            return _vm.clickEdit(item.id, index)
                          },
                        },
                      },
                      [
                        _vm.optionItems.length > 1
                          ? _c(
                              "div",
                              { staticClass: "dnd_icon option-drag-handle" },
                              [
                                _c("svg-sprite", {
                                  attrs: { name: "dragdrop", size: 20 },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          class: [
                            "color_bg",
                            item.draggable ? "option-drag-handle" : "",
                          ],
                          style: { background: item.value },
                          on: {
                            click: function ($event) {
                              return _vm.togglePalette(item.id, index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "buttons" }, [
                          _c(
                            "div",
                            {
                              staticClass: "buttons__arrow",
                              on: {
                                click: function ($event) {
                                  return _vm.togglePalette(item.id, index)
                                },
                              },
                            },
                            [
                              _c("svg-sprite", {
                                attrs: {
                                  name: "drop-down",
                                  type: "bold",
                                  size: 24,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.optionItems.length > 1
                            ? _c(
                                "div",
                                { staticClass: "buttons__delete" },
                                [
                                  _c("icon-button", {
                                    attrs: {
                                      icon: { name: "delete", size: 20 },
                                      size: "small",
                                    },
                                    on: {
                                      onClick: function ($event) {
                                        return _vm.deleteOption(item.id)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button_add" },
          [
            _c("vgp-button", {
              staticClass: "gp_autotest_columns_bar_add_color_option",
              attrs: {
                label: _vm.locale("common_add"),
                type: "text",
                icon: { name: "plus-1", type: "bold", size: 20 },
                "icon-side": "left",
                "x-small": true,
              },
              on: { onClick: _vm.addOption },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isShowColorsDropdown
        ? _c("context-menu", {
            attrs: { position: _vm.positionColorsDropdown },
            on: { onClickOutside: _vm.onClickOutside },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("vgp-colors-list", {
                        attrs: {
                          colors: _vm.colors,
                          selected: [_vm.selectedColorId],
                        },
                        on: { selectColors: _vm.onChangeColor },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3407645582
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }